const Features=({number,feature})=>
{
    return(
        <div style={{fontFamily:"Inter"}} className="text-[#B88952] py-[16px] pl-[18px] sm:w-auto lg:w-[280px] border-l-2 border-[#B88952]">
            <p className="sm:text-[26px] lg:text-[36px] font-[700] sm:leading-[32px] lg:leading-[46px] sm:pb-[2px] lg:pb-[16px]">{number}</p>
            <p className="sm:text-[16px] lg:text-[20px] font-[400] leading-[30px]">{feature}</p>
        </div>
    )
}
export default Features